export default __webpack_public_path__ + "static/media/pos-billing.6e6bc65f.jpg";